import RootStore from './root-store';
import WorkerBuilder from '../utils/workers/worker-builder';
import asyncWorker from '../utils/workers/worker';

interface Timer {
  uid: number;
  type: 'setTimeout';
  time: number;
  func: (...args: any[]) => void;
  arg?: any;
}

class AsyncStore {
  rootStore: RootStore;
  timers: Record<number, Timer>; // The timers object maps UIDs to Timer objects
  worker: Worker | any;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.timers = {};
    this.worker = new WorkerBuilder(asyncWorker);
    this.initWorker();
  }

  setTimeout(func: (...args: any[]) => void, time = 1000, arg?: any): number {
    const data: Timer = {
      uid: Math.floor(Math.random() * 10000000000),
      type: 'setTimeout',
      time,
      func,
      arg,
    };

    this.timers[data.uid] = data;
    this.worker.postMessage(JSON.stringify(data));

    return data.uid;
  }

  clearTimeout(uid: number): void {
    if (uid && this.timers[uid]) {
      delete this.timers[uid];
    }
  }

  initWorker(): void {
    this.worker.onmessage = (message: MessageEvent): void => {
      let data: { uid: number; arg?: any } | null = null;

      try {
        data = JSON.parse(message.data);
      } catch (e) {
        console.error('Couldn\'t parse data from worker', e);
      }

      if (data && this.timers[data.uid] && typeof this.timers[data.uid].func === 'function') {
        this.timers[data.uid].func(data.arg);
        delete this.timers[data.uid]; // Clean up the timer after execution
      }
    };
  }
}

export default AsyncStore;
